var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { AddRowComponent } from '../../../../component/addrow/addrow.component';
import { AddRowService } from '../../../../component/addrow/addrow.service';
import { KtsOutlineService } from './outline.service';
var KtsOutlineFieldComponent = /** @class */ (function (_super) {
    __extends(KtsOutlineFieldComponent, _super);
    function KtsOutlineFieldComponent(router, route, logger, action, message, page, service, outlineService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.outlineService = outlineService;
        _this.changeField = new EventEmitter();
        _this.fieldCols = [];
        _this.vals = [];
        _this.deleteFlg = false;
        return _this;
    }
    KtsOutlineFieldComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsOutlineFieldComponent.prototype.ngOnChanges = function (changes) {
        if (changes.vals && changes.vals.firstChange) {
            this.outlineService.setFieldComp(this.componentName);
            this.primaryKey = jsonpath.value(this.component, '$.params.primaryKey') || '';
            this.cols = $.extend(true, [], this.fieldCols);
            this.outlineService.sortItems(this.vals[this.cols[0].key]);
            this.deleteFlg = false;
            _super.prototype.onSubscribe.call(this, this.vals);
        }
    };
    KtsOutlineFieldComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.cols = $.extend(true, [], this.fieldCols);
        this.orgCols = $.extend(true, [], this.cols);
        _super.prototype.checkReadonly.call(this);
    };
    KtsOutlineFieldComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'delete') {
            if (typeof this.items[index][this.primaryKey] !== 'undefined' && this.items[index][this.primaryKey] !== null) {
                this.deleteFlg = true;
            }
        }
        _super.prototype.onEvent.call(this, e1, e2, index);
    };
    KtsOutlineFieldComponent.prototype.setOrder = function () {
        var order = 1;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            item['disp_order'] = order;
            order++;
        }
    };
    KtsOutlineFieldComponent.prototype.setCompRec = function () {
        this.setOrder();
        this.changeField.emit({ key: this.cols[0].key, val: this.items, delFlg: this.deleteFlg });
    };
    KtsOutlineFieldComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-outline-field',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" addrowDir></dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly || !sortKey\" scope=\"col\"></th>\n        <th [hidden]=\"readonly || !deletable\" scope=\"col\"></th>\n        <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n          <th *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" scope=\"col\">\n            <a a class=\"-fixed\">{{ col.label }}</a>\n          </th>\n        </ng-template>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly || !sortKey\" class=\"tableWrapper_arrowTd\">\n            <ul class=\"stageFlow_arrows\">\n              <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li><a *ngIf=\"index < dispItems.length - 1\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n            </ul>\n          </td>\n          <td [hidden]=\"readonly || !deletable\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"item?.$editable\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n            <td *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" [col]=\"col\" listDir>\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: item.$editable ? col.readonly : true,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" [err]=\"errItems[index] || {}\" (setChangeVal)=\"onChangeRow($event, index)\" (clickCol)=\"onClickRow($event, index)\"></column>\n            </td>\n          </ng-template>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"addable && !readonly && (maxRows === null || dispItems.length < maxRows)\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onEvent($event, 'add', '')\"></button>\n      </p>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsOutlineFieldComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService },
        { type: KtsOutlineService }
    ]; };
    KtsOutlineFieldComponent.propDecorators = {
        changeField: [{ type: Output }],
        fieldCols: [{ type: Input }],
        vals: [{ type: Input }]
    };
    return KtsOutlineFieldComponent;
}(AddRowComponent));
export { KtsOutlineFieldComponent };
//# sourceMappingURL=outline-field.component.js.map